module.exports = __webpack_public_path__ + "static/media/nftkey.d2b0f053.png";